import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["button", "arrows", "mod_name", "textfield"];
  }
  initialize() {
    console.log("Search mod controller is working!");
  }

  connect() {
    const button = this.buttonTarget;
    const arrows = this.arrowsTarget;
    const mod_name = this.mod_nameTarget;
    const textfield = this.textfieldTarget;

    const url = new URLSearchParams(location.search);

    if (url.has("game_mod_id")) {
      button.classList.remove("hidden");
      arrows.classList.add("hidden");
      textfield.value = mod_name.innerText;
    }
  }
}
